import { Color } from "./base-data";

const colors: Color[][] = [
  ["G", "G", "G", "Y", "Y", "Y", "Y", "G", "B", "B", "B", "O", "Y", "Y", "Y"],
  ["O", "G", "Y", "G", "Y", "Y", "O", "O", "R", "B", "B", "O", "O", "G", "G"],
  ["B", "G", "R", "G", "G", "G", "G", "R", "R", "R", "Y", "Y", "O", "G", "G"],
  ["B", "R", "R", "G", "O", "O", "B", "B", "G", "G", "Y", "Y", "O", "R", "B"],
  ["R", "O", "O", "O", "O", "R", "B", "B", "O", "O", "O", "R", "R", "R", "R"],
  ["R", "B", "B", "R", "R", "R", "R", "Y", "Y", "O", "R", "B", "B", "B", "O"],
  ["Y", "Y", "B", "B", "B", "B", "R", "Y", "Y", "Y", "G", "G", "G", "O", "O"],
];

const stars: boolean[][] = [
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    true,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ],
  [
    false,
    true,
    false,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    false,
    false,
    true,
  ],
  [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
  ],
];

export const board = {
  colors,
  stars,
};
